<div style="margin: 6px 10px 10px 10px;">
  <form [formGroup]="SettingsForm">
    <legend>Event Settings</legend>
    <div style="height: 10px;"></div>
    <div style="font-weight: bold; text-decoration: underline;">Log Events</div>
    <div style="height: 10px;"></div>
    <div class="mb-3 row">
      <div class="col-lg-12">
        <input type="checkbox" [formControl]="LogEvents" />
        <span class="uv-checkbox-label">Record events in the event log</span>
      </div>
    </div>
    <div style="font-weight: bold; text-decoration: underline;">Email Events</div>
    <div style="height: 10px;"></div>
    @if (!IsEmailConfigured) {
      <div class="mb-3 row">
        <div class="col-lg-12 alert alert-danger" style="margin-bottom: 0px;">
          <span>SMTP server settings must be specified in the Network Settings</span>
        </div>
      </div>
    }
    <div class="mb-3 row">
      <div class="col-lg-12">
        <input type="checkbox" [formControl]="EmailEvents" (change)="enableDisableControls()" />
        <span class="uv-checkbox-label">Send email notification containing events</span>
      </div>
    </div>
    <div class="mb-3 row row-2">
      <div class="col-lg-12">
        <span>Recipient Addresses:</span>
        <input type="text" pInputText style="margin-left: 5px; width: 500px;"
          [formControl]="EmailRecipients" />
        </div>
      </div>
      <div class="mb-3 row row-2">
        <div class="col-lg-12">
          <input id="schedDiscIncludeSystemRecipients" type="checkbox" style="margin-top: 11px;"
            [formControl]="IncludeSystemRecipients" />
            <span class="uv-checkbox-label" style="margin-right: 10px;">Include System Recipients</span>
            <input type="text" pInputText style="width: 500px;" [formControl]="SystemRecipients" />
          </div>
        </div>
        <div class="mb-3 row row-2">
          <div class="col-lg-12">
            <input type="checkbox" [formControl]="EmailEventsOnChangesOnly" />
            <span class="uv-checkbox-label">Notify on Changes Only</span>
          </div>
        </div>
        <div class="mb-3 row row-2">
          <div class="col-lg-12">
            <input type="checkbox" [formControl]="AttachAssetsReport" />
            <span class="uv-checkbox-label">Attach Assets Report</span>
          </div>
        </div>
        <div class="mb-3 row row-2">
          <div class="col-lg-12">
            <input type="checkbox" [formControl]="AttachDeviceConnectivityReport" />
            <span class="uv-checkbox-label">Attach Device Connectivity Report</span>
          </div>
        </div>
        <div style="font-weight: bold; text-decoration: underline;">Slack Events</div>
        <div style="height: 10px;"></div>
        <div class="col-lg-3">
          <div class="col-lg-12">
            <input type="checkbox" [formControl]="SlackEvents" (change)="enableDisableControls()" />
            <span class="uv-checkbox-label">Send Slack notification containing events</span>
          </div>
          <div class="mb-3 row row-2" style="margin-top: 10px;">
            <div class="col-lg-12">
              <input type="checkbox" [formControl]="SlackEventsOnChangesOnly" />
              <span class="uv-checkbox-label">Notify on Changes Only</span>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <span>Webhook URLs:</span>
          <div>
            <textarea [formControl]="SlackWebhooks" rows="5" cols="100" placeholder="Paste your URLs here"></textarea>
          </div>
        </div>
        <div style="margin-top: 10px;">
          <div class="col-lg-12">
            <button type="button" (click)="testSlack()"	pButton icon="fa" label="Test Slack"
              [disabled]="!enableTestSlackButton" title="Test/Verify Slack connection">
            </button>
          </div>
        </div>
      </form>
    </div>
